import React, { useEffect } from 'react'
import { Outlet, Link, useRoutes, useParams, useLocation } from 'react-router-dom'

import Navigation from '../../components/Navigation'

import styles from './index.module.scss'

export default function Layout() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])
  return (
    <div className={styles.app}>
      <Outlet></Outlet>
      <Navigation />
    </div>
  )
}
